<template>
  <v-container>
    <v-row justify="center">
      <v-col
        align="center"
        cols="6"
        md="2"
        :class="providerQportal"
        style="cursor:pointer;"
        @click="changeProvider('qportal')"
      >
        <v-icon color="#066a8c">mdi-post-outline</v-icon>
        <div class="mnuBtn">QPortal</div>
      </v-col>

      <v-col
        align="center"
        cols="6"
        md="2"
        :class="providerPriohub"
        @click="changeProvider('priohub')"
        style="cursor:pointer;"
      >
        <v-icon color="#066a8c">mdi-view-dashboard</v-icon>
        <div class="mnuBtn">Priohub</div>
      </v-col>
    </v-row>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row no-gutters class="ma-3 header_title">
                <v-col cols="12" md="2" class="pt-6">
                  Sales
                  <br />
                  <br />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="ml-4" cols="2">
                  <v-autocomplete
                    v-model="searchParams.time_intervel"
                    outlined
                    label="Time Period"
                    @change="changeFxn"
                    item-value="name"
                    item-text="title"
                    :items="timeDuration"
                  ></v-autocomplete>
                </v-col>

                <v-col class="ml-1" cols="4" v-if="flag">
                  <v-row>
                    <v-col cols="5" style="padding-right: 0">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            outlined
                            background-color="#fff"
                            class="text1"
                            v-model="date1Formatted"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="searchParams.start_date"
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="5">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="text2"
                            v-model="date2Formatted"
                            outlined
                            background-color="#fff"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="searchParams.end_date"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="2">
                      <v-flex xs1 class="ml-1 mt-1">
                        <v-btn
                          color="#00b0af"
                          height="48"
                          dark
                          @click="getFilterData"
                          >Go</v-btn
                        >
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-col>

                <v-spacer></v-spacer>
                <v-col md="2" class="mr-3">
                  <div style="width: 120px; float: right">
                    <v-select
                      outlined
                      v-model="perPage"
                      label="Per Page"
                      :items="[10, 15, 25, 50]"
                      @change="getFilterData"
                      :menu-props="{ bottom: true, offsetY: true }"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div
              class="md-content md-table md-theme-default table_borders"
              table-header-color="orange"
              value
            >
              <div
                class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                    <tr>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Timestamp</div>
                        </div>
                      </th>
                      <th class="md-table-head" style="width:170px;">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Order Number</div>
                        </div>
                      </th>

                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Name</div>
                          <div class="search_column">
                            <v-autocomplete
                              solo
                              filled
                              label="Name"
                              v-model="searchParams.name"
                              item-value="name"
                              item-text="name"
                              :items="names"
                              :loading="isLoading"
                              :search-input.sync="name"
                              @change="getFilterData"
                            ></v-autocomplete>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Post</div>
                          <div class="search_column">
                            <v-autocomplete
                              solo
                              filled
                              label="Title"
                              v-model="searchParams.title"
                              item-value="title"
                              item-text="title"
                              :items="titles"
                              :loading="isLoading"
                              :search-input.sync="title"
                              @change="getFilterData"
                            ></v-autocomplete>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Venue Name</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Service</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Start Date</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">End Date</div>
                        </div>
                      </th>
                      <th class="md-table-head" style="width:170px;">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Price</div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="md-table-row"
                      v-for="(data, index) in sales"
                      :key="index"
                    >
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.order_created_at }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.order_seq_no }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          <v-btn
                            small
                            color="#00b0af"
                            class="d-inline-block text-truncate"
                            style="
                          max-width: 130px;
                          min-width: 130px;
                          text-transform: none;
                        "
                            dark
                            @click="
                              $router.push({
                                name: 'ViewUser',
                                params: { userId: data.user_id },
                              })
                            "
                          >
                            <span class="text-truncate">{{
                              data.name
                            }}</span></v-btn
                          >
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          <v-btn
                            small
                            color="#00b0af"
                            class="d-inline-block text-truncate"
                            style="
                          max-width: 130px;
                          min-width: 130px;
                          text-transform: none;
                        "
                            dark
                            @click="showPostModel(data.post_id)"
                          >
                            <span class="text-truncate">{{
                              data.post_name
                            }}</span></v-btn
                          >
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.venue_name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.service_name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.start_date + " " + data.start_time || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.end_date + " " + data.end_time || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ "AED " + data.total_price }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :page="page"
              total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
    <post-model v-bind="postModel" @close="postModel.postID = null" />
    <user-model v-bind="UserModel" @close="UserModel.userID = null" />
    <!-- <order-model v-bind="OrderModel" @close="OrderModel.orderID = null" /> -->
  </v-container>
</template>
<script>
import PostModel from "../Feeds/Post/PostModel";
import UserModel from "../Users/User/UserModel";
import moment from "moment";
// import OrderModel from "./OrderModel";
export default {
  components: {
    PostModel,
    UserModel,
    //OrderModel,
  },
  data() {
    return {
      providerQportal: "btn_bg",
      providerPriohub: null,
      sales: [],
      page: 1,
      totalPages: 1,
      perPage: null,
      titles: [],
      flag: false,
      title: null,
      names: [],
      name: null,
      isLoading: false,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      searchParams: {
        timestamp: null,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 6) || "Min 6 characters",
      },
      nameRules: [(v) => !!v || "Name is required"],
      height: 500,
      postModel: { postID: null, type: "details" },
      UserModel: { userID: null, type: "details" },
      OrderModel: { orderID: null, type: "details" },
      third_party: "qportal",
      timeDuration: [
        { name: "All", title: "All" },
        { name: "week", title: "This Week" },
        { name: "year", title: "This Year" },
        { name: "month", title: "This Month" },
        { name: "custom", title: "Custom Duration" },
      ],
      menu1: false,
      menu2: false,
    };
  },
  mounted() {
    this.getSales();
  },
  computed: {
    date1Formatted() {
      return moment(this.searchParams.start_date, "YYYY-MM-DD").format(
        "Do MMM YYYY"
      );
    },
    date2Formatted() {
      return moment(this.searchParams.end_date, "YYYY-MM-DD").format(
        "Do MMM YYYY"
      );
    },
  },
  watch: {
    page() {
      this.getSales();
    },
    title(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("title", val);
    },
    name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("name", val);
    },
  },
  methods: {
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
        .get("admin/sales/filter-order?field=" + type + "&search=" + val)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            console.log("response.data.data");
            console.log(response.data.data);
            if (type == "title") {
              this.titles = response.data.data;
              this.titles.unshift(val);
              this.titles.unshift("All");
            } else if (type == "name") {
              this.names = response.data.data;
              this.names.unshift(val);
              this.names.unshift("All");
            }
          }
        })

        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getFilterData() {
      this.page = 1;
      this.getSales();
    },
    getSales() {
      let url = "";
      if (
        typeof this.searchParams.title != "undefined" &&
        this.searchParams.title !== "All"
      ) {
        url += "&title=" + this.searchParams.title;
      }
      if (
        typeof this.searchParams.name != "undefined" &&
        this.searchParams.name !== "All"
      ) {
        url += "&name=" + this.searchParams.name;
      }
      if (
        this.searchParams.time_intervel != "All" &&
        this.searchParams.time_intervel != null
      ) {
        // this.searchParams.end_date = moment().format("YYYY-MM-DD");
        if (this.searchParams.time_intervel == "custom") {
          this.flag = true;
        } else if (this.searchParams.time_intervel == "week") {
          this.searchParams.start_date = moment()
            .startOf("week")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "month") {
          this.searchParams.start_date = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "year") {
          this.searchParams.start_date = moment()
            .startOf("year")
            .format("YYYY-MM-DD");
        }
        url += "&end_date=" + this.searchParams.end_date;
        url += "&start_date=" + this.searchParams.start_date;
      }

      if (this.third_party == "priohub") {
        url += "&provider=priohub";
      } else {
        url += "&provider=qportal";
      }
      this.$http
        .get(
          "admin/sales?per_page=" + this.perPage + "&page=" + this.page + url
        )
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.sales = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeFxn() {
      if (this.searchParams.time_intervel == "custom") {
        this.searchParams.start_date = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        this.searchParams.end_date = moment().format("YYYY-MM-DD");
        this.flag = true;
      } else {
        this.flag = false;
        this.getSales();
      }
    },
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
    showUserModel(userId) {
      this.UserModel.userID = parseInt(userId);
      this.UserModel.type = "details";
    },
    changeProvider(sel) {
      if (sel == "qportal") {
        this.third_party = "qportal";
        this.providerQportal = "btn_bg";
        this.providerPriohub = "";
      } else {
        this.third_party = "priohub";
        this.providerPriohub = "btn_bg";
        this.providerQportal = "";
      }
      // this.changeThirdParty();
      this.getSales();
      this.$forceUpdate();
    },
    // showOrderModel(orderId) {
    //   this.OrderModel.orderID = parseInt(orderId);
    //   this.OrderModel.type = "details";
    // },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
